<template>
  <div class="profile-hero">
    <ProfileImage
      :source="userData.profile_pic || userData.big_thumbnail"
      :accountActive="!userData.accountNotActivated"
    />
    <div class="column">
      <watchlist-button
        v-if="userCanUseWatchlist"
        :active="existsInWatchlist"
        @add-to-watchlist="updateWatchlist"
      />

      <div class="mb-2">
        <label>Geburtsdatum</label>
        <b>{{ formatDate }} ({{ dateToAge }})</b>
      </div>
      <div class="mb-2">
        <label>Trainertyp</label>
        <b>{{ userData.trainer_type }}</b>
      </div>
      <div class="mb-2">
        <label>Trainerlizenz</label>
        <b v-if="userData.license === 'Eigene Angabe'">{{ userData.custom_license }}</b>
        <b v-else>{{ userData.license }}</b>
      </div>
      <div class="mb-2" v-if="userData.trainer_since">
        <label>Trainer/in seit</label>
        <b>{{ formatSinceDate }}</b>
      </div>
    </div>

    <div class="column">
      <div class="mb-2">
        <label for>Nationalität</label>
        <b>
          <flag class="flag" :iso="userData.nationality" />
          {{ getNationality }}
        </b>
      </div>
      <div class="mb-2">
        <label>
          <span v-if="userData.no_team === true || userData.no_team === 'nein'"
            >Aktueller</span
          >
          <span v-else>Letzter</span> Verein
        </label>
        <b>{{ userData.currentTeam }}</b>
      </div>
    </div>
    <div class="column">
      <div class="mb-2" v-if="userData.living_in_country || userData.nationality">
        <label>Wohnsitz (Land)</label>
        <div v-if="userData.living_in_country">
          <flag class="flag" :iso="getCountryShort" />
          <b>{{ userData.living_in_country }}</b>
        </div>
        <div v-else>
          <flag class="flag" :iso="userData.nationality" />
          <b>{{ getNationality }}</b>
        </div>
      </div>
      <div
        class="mb-2"
        v-if="
          (userData.no_team === true || userData.no_team === 'nein') &&
          userData.category
        "
      >
        <label>Aktuelle Liga</label>
        <b>{{ userData.category.league }}</b>
      </div>
      <div
        class="mb-2"
        v-if="
          (userData.no_team === false || userData.no_team === 'ja') && userData.category
        "
      >
        <label>Letzte Liga</label>
        <b>{{ userData.category.league }}</b>
      </div>
    </div>

    <ProfilLinks :userData="userData" />

    <div class="column-span mt-2 pb-2">
      <label>Bio</label>
      {{ userData.bio }}
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import ProfileImage from './ProfileImage';
import ProfilLinks from './ProfilLinks';
import WatchlistButton from '@/components/profile/WatchlistButton.vue';
import watchlistMixin from '@/mixins/watchlist';

export default {
  name: 'profile-trainer-data',

  props: {
    userData: {
      type: Object,
      default: () => {},
    },
  },

  components: {
    ProfileImage,
    ProfilLinks,
    WatchlistButton,
  },

  mixins: [watchlistMixin],

  computed: {
    formatDate() {
      if (!this.userData.age) return null;

      const [year, month, day] = this.userData.age.split('-');
      return `${day}.${month}.${year}`;
    },

    dateToAge() {
      if (!this.userData.age) return null;
      const [year, month, day] = this.userData.age.split('-');
      const dateString = `${year}-${month}-${day}`;
      const age = moment().diff(dateString, 'years');
      return age;
    },

    getNationality() {
      if (this.userData.nationality) {
        const found = this.$store.state.nationalities.find(
          (element) => element.id === this.userData.nationality,
        );
        return found.item_text;
      }
      return '';
    },

    getCountryShort() {
      const found = this.$store.state.nationalities.find(
        (element) => element.item_text === this.userData.living_in_country,
      );
      return found.id;
    },

    formatSinceDate() {
      return this.userData.trainer_since
        ? moment(this.userData.trainer_since).format('MM/YYYY')
        : '';
    },
  },
};
</script>
